import React from 'react';
import styled from 'styled-components';

import { ServicesCard } from 'components';
import { Text } from 'components/typography';
import Button from '../components/Button';
import Section from '../components/Section';
import './Services.scss';

const AuditContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${({ theme }) => theme.palette.blueBase};
  text-align: center;
  padding: 8rem 2.4rem;

  ${({ theme }) => theme.breakpoints.maxMobile} {
    padding: 4.8rem 2.4rem;
  }
`;

const AuditDescription = styled(Text)`
  color: ${({ theme }) => theme.palette.whiteBase};
  max-width: 63.2rem;
  margin-bottom: 4rem;
  font-size: 1.4rem;

  ${({ theme }) => theme.breakpoints.maxTablet} {
    max-width: 40rem;
  }

  ${({ theme }) => theme.breakpoints.maxMobile} {
    margin-bottom: 2.4rem;
  }
`;

const Services = ({
  data: {
    sectionTitle: { subTitle, title, button },
    cards,
    audit,
  },
}) => (
  <Section className="services" title={title} subTitle={subTitle} button={button}>
    <div className="services__cards-container">
      {cards.map((card, index) => (
        <ServicesCard
          image={card.imageContainer.image.publicURL}
          altText={card.imageContainer.altText}
          title={card.title}
          description={card.description}
          key={card.title}
          index={index}
        />
      ))}
    </div>
    <Button
      className="services__button-mobile"
      variant="secondary"
      data-sal="slide-left"
      data-sal-easing="ease"
      to={button.url}
    >
      {button.text}
    </Button>
    <AuditContainer>
      <h2 className="services__audit-title" data-sal="slide-up" data-sal-easing="ease">
        {audit.auditTitle}
      </h2>
      <div data-sal="slide-up" data-sal-easing="ease">
        <AuditDescription>{audit.description}</AuditDescription>
      </div>
      <div data-sal="slide-up" data-sal-easing="ease">
        <Button variant="secondaryWhite" to={audit.button.url}>
          {audit.button.text}
        </Button>
      </div>
    </AuditContainer>
  </Section>
);
export default Services;
